module.exports = __webpack_public_path__ + "static/media/jcb.svg.f8ab18dc.png";